import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      console.warn("Unauthorized. Redirecting to login.");
      document.cookie = 'support_token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;';
      window.location.href = '/login';
    }

    if (error.response && error.response.status >= 500) {
      console.error("Server error. Redirecting to login.");
      window.location.href = '/login';
    }

    return Promise.reject(error);
  }
);

createApp(App)
  .use(router)
  .mount('#app');